import React from "react";
import { withFormik, Form, Field } from "formik";
import { warningAlert } from "@/utility/helpers";
import { getActiveShop } from "@/constants/utility";

import * as Yup from "yup";

const AdminCodeForm = ({ close, errors, isSubmitting, touched, httpClient, user }) => {
  const shop = getActiveShop(user);
  const handleReset = async() => {
    try {
    await httpClient.post("/account/forgotpin", {
      email: user.email,
      repairshopID: shop._id
    })
    .then((res) => {
      warningAlert({
        message:
          res.message,
        status: "success",
      });
    })
    // window.location.reload();
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        warningAlert({ api: err.response.data.message }); 
      } else {
        warningAlert({ api: 'An unexpected error occurred.' }); 
      }
    }
  };
  return (
    <Form className="uk-form-stacked">
      <div className="uk-placeholder_">
        <div className={"uk-child-width-1-1 uk-grid-small"} uk-grid={1}>
          <div className="uk-width-1-1">
            <label className="uk-form-label uk-text-left" htmlFor="inputValue">
              {/* {label} */}
            </label>
            <div className="uk-form-controls">
              <div className={`uk-card uk-card-body border-default padding-10 bg-white border-radius-15  uk-width-1-1 ${touched.inputValue && errors.inputValue
                && "uk-form-danger uk-animation-shake"}`}>
                <label className="uk-form-label uk-text-left uk-margin-small-left uk-text-bold" htmlFor="cost">
                  Admin Pin
                </label>
                <div className="uk-form-controls">
                  <Field className={`uk-input borderless_input uk-form-small`} id="inputValue"
                    type="password"
                    name="inputValue"
                    placeholder="" />
                </div>
              </div>
              <div>
                <a className="uk-form-label uk-text-left uk-margin-small-left uk-text-bold" 
                  htmlFor="cost"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleReset();
                  }}
                 >
                  Reset Admin Pin
                </a>
              </div>
              {/* <Field
                className={[
                  "uk-input uk-form-width-medium",
                  touched.inputValue && errors.inputValue
                    ? "uk-form-danger uk-animation-shake"
                    : "",
                ].join(" ")}
                id="inputValue"
                type="password"
                name="inputValue"
                placeholder=""
              /> */}
            </div>
          </div>
        </div>
        {/* <hr className=" uk-divider-icon uk-margin-small" /> */}
      </div>

      <div className="uk-text-right uk-margin-top">
        <button
         onClick={close}
         type="button"
          className="uk-width-1-5 uk-button uk-button-default uk-text-capitalize">
          Cancel
        </button>
        <button
          disabled={isSubmitting}
          type="submit"
          className="uk-width-1-5 uk-button uk-button-danger uk-margin-left uk-text-capitalize">
          {isSubmitting ? (
            <i className="fa fa-spinner fa-spin fa-fw"></i>
          ) : (
            "Update"
          )}
        </button>

      </div>
    </Form>
  );
};

const FormikAdminToken = withFormik({
  mapPropsToValues({ inputValue }) {
    return {
      inputValue: inputValue || "",
    };
  },
  validationSchema: Yup.object().shape({
    inputValue: Yup.string().required(),
  }),
  handleSubmit(values, { props, resetForm, setErrors, setSubmitting }) {
   props.handleSubmit(values.inputValue).then(() => {setSubmitting(false)}).catch((err) => {setSubmitting(false)});
  },
})(AdminCodeForm);

export default FormikAdminToken;
